import * as React from 'react'

import { Avatar, Box, Button, List, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employees: Employee[]
  title: string
  description: string
  primaryButtonLabel: string
  onClose: () => void
  onPrimaryButtonClick: () => void
}
const MissingEmployeesModal = ({
  title,
  description,
  primaryButtonLabel,
  employees,
  onClose,
  onPrimaryButtonClick,
}: Props) => {
  const numberOfEmployees = employees.length

  return (
    <Modal
      title={title}
      description={description}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('payroll_bundle.payroll_results.missing_employees_modal.got_it_button_label')}
          </Button>

          <Button onClick={onPrimaryButtonClick}>{primaryButtonLabel}</Button>
        </>
      }
      illustration="money-bag"
      onClose={onClose}
    >
      <Box maxHeight="s240" overflowY="auto">
        <List>
          {employees.map((employee, index) => (
            <Box
              key={employee.id}
              component="li"
              padding="s16"
              flexDirection="row"
              alignItems="center"
              border={{
                bottom:
                  numberOfEmployees === index + 1
                    ? undefined
                    : { width: 's1', color: 'grey400', style: 'solid' },
              }}
              gap="s16"
            >
              <Avatar
                size="s40"
                url={buildUrl(employeeUser(employee).avatar)}
                label={employeeUser(employee).fullName()}
              />
              <Text.Normal ellipsis color="grey800" size="300">
                {employeeUser(employee).fullName()}
              </Text.Normal>
            </Box>
          ))}
        </List>
      </Box>
    </Modal>
  )
}

export default observer(MissingEmployeesModal)
